document.addEventListener("DOMContentLoaded", function () {
  // Sticky header
  var header = document.querySelector(".sticky-header-wrapper");
  if (!header) return; // safely exit if element not found

  var sticky = header.offsetTop; // use offsetTop, not offsetHeight

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  });
});

